import { Components } from "@mui/material/styles";
import { palette } from "../../../assets/palette";

export const MuiButton: Components['MuiButton'] = {
    defaultProps: {
        disableElevation: true,
        disableRipple: true,
        variant: 'contained'
    },
    styleOverrides: {
        root: {
            color: palette.background.white,
            fontFamily: "Roboto",
            fontWeight: 500,
            textAlign: "left",
            border: 'none',
            outline: 'none',
            textTransform: 'none',
            cursor: 'pointer',
            borderRadius: '2px',
            boxShadow: 'unset',
        },
        outlinedSizeSmall: {
            height: '40px',
            fontSize: "16px",
            letterSpacing: "0.2px",
            lineHeight: "15px",
            padding: '0 16px',
        },
        outlinedPrimary: {
            border: `1px solid ${palette.primary.richElectricBlue}`,
            backgroundColor: palette.background.white,
            color: palette.primary.richElectricBlue,
            ':hover': {
                backgroundColor: palette.primary.richElectricBlue,
                color: palette.background.white,
                boxShadow: 'unset',
            },
            ':disabled': {
                color: palette.primarycolumbiaBlue,
                backgroundColor: palette.background.white,
                border: `1px solid ${palette.primary.primarycolumbiaBlue}`,
            }
        },
        containedSizeSmall: {
            height: '40px',
            fontSize: "16px",
            letterSpacing: "0.2px",
            lineHeight: "15px",
            padding: '0 16px',
        },
        containedPrimary: {
            backgroundImage: `linear-gradient(90deg, ${palette.primary.richElectricBlue}, ${palette.primary.cyanProgress})`,
            ':hover': {
                backgroundImage: `linear-gradient(${palette.primary.cyanProgress}, ${palette.primary.cyanProgress})`,
                boxShadow: 'unset',
            },
            ':disabled': {
                background: palette.primary.columbiaBlue,
                color: palette.background.white,
            }
        },
        containedSecondary: {
            backgroundColor: '#D82829',
            ':hover': {
                backgroundColor: '#FC4E3D!important'
            }
        }
    }
};
